import { CatalogsMatcherTaskState } from './state';
import { apiUrl } from '@/env';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import { ICatalogsMatcherTask, ICatalogsMatcherOneTaskStat, ICatalogsMatcherTasksStatData } from '@/interfaces/catalogs-matcher';
import { catalogsMatcherEndpoint } from '@/constants';


export const mutations = {
  setCatalogsMatcherTasks(state: CatalogsMatcherTaskState, payload: ICatalogsMatcherTask[]) {
    // добавляем флаг isExporting; его пока нет в PG
    // если isExporting = true, иконка загрузки файлов заблокирована
    payload.forEach((item) => {
      item.isExporting = state.tasks.find((task) => task.id === item.id)?.isExporting;
      item.isDownloading = state.tasks.find((task) => task.id === item.id)?.isDownloading;
      if (item.status === 'ACTIVE') {
        const taskActive = state.tasks.find((t) => t.id === item.id);
        if (taskActive && taskActive.stats) item.stats = taskActive.stats;
      }
      if (item.isExporting) item.status = 'EXPORT';
      else if (item.isDownloading) item.status = 'DOWNLOAD';
    });
    state.tasks = payload;
  },
  setCatalogsMatcherTask(state: CatalogsMatcherTaskState, payload: ICatalogsMatcherTask) {

    // const newList: ICatalogsMatcherTask[] = state.yt_tasks.slice();
    // const index = newList.findIndex(item => item.id === payload.id);
    // if (index !== -1) {
    //     newList[index] = payload;
    //     state.yt_tasks = newList;
    // };

    // самый быстрый вариант
    const newList: ICatalogsMatcherTask[] = state.tasks.slice();
    for (let i = 0; i < newList.length; i++)
      if (newList[i].id === payload.id) {
        newList[i] = payload;
        break;
      }
    state.tasks = newList;
  },

  // изменяем флаг isExporting
  setCatalogsMatcherTaskIsExporting(state: CatalogsMatcherTaskState, payload: { id: number, isExporting: boolean}) {
      const task = state.tasks.find((item: ICatalogsMatcherTask) => item.id === payload.id);
      if (task) task.isExporting = payload.isExporting;
  },

  // изменяем флаг isDownloading
  setCatalogsMatcherTaskIsDownloading(state: CatalogsMatcherTaskState, payload: { id: number, isDownloading: boolean}) {
      const task = state.tasks.find((item: ICatalogsMatcherTask) => item.id === payload.id);
      if (task) task.isDownloading = payload.isDownloading;
  },

  setCatalogsMatcherTaskStatus(state: CatalogsMatcherTaskState, payload: { id: number, status: string}) {
      const task = state.tasks.find((item: ICatalogsMatcherTask) => item.id === payload.id);
      if (task) task.status = payload.status;
  },

  setCatalogsMatcherTasksStat(state: CatalogsMatcherTaskState, payload: ICatalogsMatcherTasksStatData) {
    if (payload.tasks)
      state.tasks = state.tasks.map((t: ICatalogsMatcherTask) => {
        const taskStat = payload.tasks.find((s: ICatalogsMatcherOneTaskStat) =>  t.id === s.task_id);
        if (taskStat) {
          t.status = taskStat.status;
          t.datetime_end = taskStat.datetime_end;

          const prev = t.stats?.prev;
          const prev_time = t.stats?.prev_time;

          t.stats = taskStat.stats;

          // записыаем стартовые значения количества найденных данных и времени
          // для расчета времени до завершения парсинга
          if (t.stats) {
            t.stats.prev = prev;
            t.stats.prev_time = prev_time;

            const curTime = new Date();

            if (t.stats.found_count > 0) {
              if (t.stats.prev === undefined)
                t.stats.prev = t.stats.found_count;

              if (t.stats.prev_time === undefined)
                t.stats.prev_time = curTime;
            }
          }

          if (taskStat.result)
            t.result = `${apiUrl}/api/v1/${catalogsMatcherEndpoint}/result/${taskStat.result}`;
        }
        return t;
      });
  },
};

const { commit } = getStoreAccessors<CatalogsMatcherTaskState, State>('');

export const commitSetCatalogsMatcherTask = commit(mutations.setCatalogsMatcherTask);
export const commitSetCatalogsMatcherTasks = commit(mutations.setCatalogsMatcherTasks);
export const commitSetCatalogsMatcherTasksStat = commit(mutations.setCatalogsMatcherTasksStat);
export const commitSetCatalogsMatcherTaskIsExporting = commit(mutations.setCatalogsMatcherTaskIsExporting);
export const commitSetCatalogsMatcherTaskIsDownloading = commit(mutations.setCatalogsMatcherTaskIsDownloading);
export const commitSetCatalogsMatcherTaskStatus = commit(mutations.setCatalogsMatcherTaskStatus);
